export default __webpack_public_path__ + "static/SharpGroteskBold15-Regular-322c515ad8331a2772031211d3201c5d.woff2";